import { Injectable, NgZone } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { grpc } from '@improbable-eng/grpc-web';

import {
  AppConfigRequest,
  AppConfigResponse,
  LocaleSyncRequest,
  LocaleSyncResponse,
  ErrorReportRequest,
  ErrorReportResponse,
} from '../gateway/connect_pb';

import {
  AppConfig as __AppConfig,
  LocaleSync as __LocaleSync,
  ErrorReporter as __ErrorReporter,
} from '../gateway/connect_pb_service';

@Injectable({providedIn: 'root'})
export class AppConfig {

  constructor(private _ngZone: NgZone) {
  }

  getAppConfig(request: AppConfigRequest): Promise<AppConfigResponse>;
  getAppConfig(request: AppConfigRequest, metadata: grpc.Metadata): Promise<AppConfigResponse>;
  getAppConfig(request: AppConfigRequest, callback: (err: any|null, response: AppConfigResponse, metadata: grpc.Metadata) => void): void;
  getAppConfig(request: AppConfigRequest, metadata: grpc.Metadata, callback: (err: any|null, response: AppConfigResponse, metadata: grpc.Metadata) => void): void;

  getAppConfig(request: AppConfigRequest, arg1?: grpc.Metadata|((err: any|null, response: AppConfigResponse, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: AppConfigResponse, metadata: grpc.Metadata) => void): Promise<AppConfigResponse>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<AppConfigResponse>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__AppConfig.getAppConfig, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

}


@Injectable({providedIn: 'root'})
export class LocaleSync {

  constructor(private _ngZone: NgZone) {
  }

  getLocaleSync(request: LocaleSyncRequest): Promise<LocaleSyncResponse>;
  getLocaleSync(request: LocaleSyncRequest, metadata: grpc.Metadata): Promise<LocaleSyncResponse>;
  getLocaleSync(request: LocaleSyncRequest, callback: (err: any|null, response: LocaleSyncResponse, metadata: grpc.Metadata) => void): void;
  getLocaleSync(request: LocaleSyncRequest, metadata: grpc.Metadata, callback: (err: any|null, response: LocaleSyncResponse, metadata: grpc.Metadata) => void): void;

  getLocaleSync(request: LocaleSyncRequest, arg1?: grpc.Metadata|((err: any|null, response: LocaleSyncResponse, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: LocaleSyncResponse, metadata: grpc.Metadata) => void): Promise<LocaleSyncResponse>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<LocaleSyncResponse>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__LocaleSync.getLocaleSync, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

}


@Injectable({providedIn: 'root'})
export class ErrorReporter {

  constructor(private _ngZone: NgZone) {
  }

  sendErrorReport(request: ErrorReportRequest): Promise<ErrorReportResponse>;
  sendErrorReport(request: ErrorReportRequest, metadata: grpc.Metadata): Promise<ErrorReportResponse>;
  sendErrorReport(request: ErrorReportRequest, callback: (err: any|null, response: ErrorReportResponse, metadata: grpc.Metadata) => void): void;
  sendErrorReport(request: ErrorReportRequest, metadata: grpc.Metadata, callback: (err: any|null, response: ErrorReportResponse, metadata: grpc.Metadata) => void): void;

  sendErrorReport(request: ErrorReportRequest, arg1?: grpc.Metadata|((err: any|null, response: ErrorReportResponse, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: ErrorReportResponse, metadata: grpc.Metadata) => void): Promise<ErrorReportResponse>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<ErrorReportResponse>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__ErrorReporter.sendErrorReport, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

}

